module.exports = __webpack_public_path__ + "static/img/2-6.5.5.f5e9883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/2-6.5.5.png
// module id = W1Mu
// module chunks = 0